module.exports = __webpack_public_path__ + "media/images/athletes/3425-df299fec362325979f6160244d88df1d.png";